import { createContext, useContext } from 'react'

export const AuthContext = createContext({
  user: null,
  session: null,
  loading: true,
  signOut: () => {},
  ticketInfo: null,
  setTicketSession: () => {},
  needsProfileSetup: false,
  markProfileComplete: () => {},
})

export const useAuthContext = () => {
  return useContext(AuthContext)
}
